import React from 'react';

import { Button } from 'reactstrap';

import {
  ModalStyled, Header, Body, Footer,
} from './styles';

const ModalFilter = ({
  isOpen,
  toggle,
  title,
  children,
  footerClick,
  footer,
  width,
  height,
  top,
  disabled,
  padding,
  overflow,
  borderbottomheader,
  paddingheader,
  textalingheader,
  backgroundcolor,
  backgroundclip,
  modallist,
  fontSizeHeader,
  boldHeader,
  textTransform,
}) => (
  <ModalStyled
    isOpen={isOpen}
    toggle={toggle}
    width={width}
    height={height}
    top={top}
    backgroundcolor={backgroundcolor}
    backgroundclip={backgroundclip}
  >
    <Header
      textTransform={textTransform}
      fontSizeHeader={fontSizeHeader}
      boldHeader={boldHeader}
      modallist={modallist}
      toggle={toggle}
      paddingheader={paddingheader}
      borderbottomheader={borderbottomheader}
      textalingheader={textalingheader}
    >
      {title}
    </Header>
    <Body padding={padding} overflow={overflow}>
      {children}
    </Body>
    {footer && footerClick && (
      <Footer disabled={disabled}>
        <Button disabled={disabled} onClick={() => footerClick()}>
          {footer}
        </Button>
      </Footer>
    )}
  </ModalStyled>
);

export default ModalFilter;
